import mixin from './mixins'
import t from './tokens'

class ThemeSettings {

  antdMainColor = t.colorPrimary
  filterSecondaryColor = '#A9C6E0'
  filterBorderColor = '#F0F0F0';

  animTime = t.animTime
  borderRadius = t.borderRadius
  border_card = `1px solid ${t.colorBorderCard}`
  border_line_color = t.colorBorderLine
  border_line = `solid 1px ${t.colorBorderLine}`
  cAddButton = '#f2f2f2'
  cAddButtonActive = '#e7e6e6'
  cAlbumBack = '#fafbfc'
  cAlbumName = '#8dabc4'
  cBackGrey = t.colorBackGrey
  cBlack = t.colorBlack

  cBlue = t.colorBlue
  cBlueActive = '#0384B8'
  cBlueDisabled = '#919191'
  cBorder = t.colorBorder
  cBorderLine = t.colorBorderLine
  cDarkBlue = t.colorDarkBlue
  cAccent = t.colorDarkBlue
  cDarkGreyText = t.colorDarkGreyText
  cDarkRed = '#c80600'
  cDanger = t.colorDanger
  cDividerLine = t.colorDivider
  cGrey = t.colorGrey
  cGreyBorder = t.colorGreyBorder
  cGreyHeader = t.colorDivider
  cGreySub = t.colorGreySub
  cGreyText = t.colorGreyText
  cDarkText = t.colorDarkText
  cFormPlaceholderText = t.colorGreyText
  cHoverBlue = t.colorHoverBlue
  cIndigo = t.colorIndigo
  cInfo = t.colorInfo
  cLightBlue = t.colorLightBlue
  cLightGrey = t.colorLightGrey
  cLinkDarkBlue = t.colorLinkDark
  cLinkLightBlue = t.colorLink
  cLinkHover = t.colorLinkHover
  cLinkText = t.colorLinkText
  cMenuBorder = t.colorMenuBorder
  cNav = t.colorGreyText
  cNavActive = '#333333'
  cOrange = t.colorOrange
  cMain = t.colorOrange
  cOrangeLight = t.colorOrangeLight
  cPaleGray = t.colorPaleGray
  cPaleGrey2 = '#fafbfc'
  cRed = t.colorDanger
  cRowActive = t.colorRowActive
  cRowFocus = '#F5FFFE'
  cRowHover = t.colorRowHover
  cSlateGray = '#656f77'
  cSuccess = t.colorSuccess
  cSuperBlack = t.colorSuperBlack
  cTextColor = t.colorText
  cWhite = t.colorWhite
  disabled_color = t.colorDisabled
  disabled_input_border_color = t.colorDisabled
  fontFamilyHeader = t.fontFamilyHeader
  fontFamilyBase = t.fontFamilyBase
  fontFamilyBaseBold = 'Open Sans-SemiBold, -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial, sans-serif'
  fontSizeBase = `1.3rem`
  gGap = t.spacingGap
  input_border_color = t.colorInputBorder
  input_border = `solid 1px ${t.colorInputBorder}`
  input_font_weight = '400'
  input_line_height = '17px'
  input_placeholder_color = t.colorInputPlaceholder
  input_text_align = 'left'
  input_text_color = t.colorDarkText
  input_text_size = t.fontSizeInput
  l = t.spacingL
  lineHeightBase = `1.714285714`
  m = t.spacingM
  sm = t.spacingSM
  mediaTriggerWidth = '945px'
  mixin = mixin
  s = t.spacingS
  ss = t.spacingSS
  shadow = t.shadow
  transitionTime = t.transitionTime
  xl = t.spacingXL
  xs = t.spacingXS
  xxl = t.spacingXXL
  xxs = t.spacingXXS
  сBlueHover = '#42C0F3'

  colorError = t.colorError
  colorWarning = t.colorWarning

  text_ellipse = (amount_lines = 1) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -moz-box;
    -moz-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: ${amount_lines};
    -webkit-box-orient: vertical;
    line-clamp: ${amount_lines};
    box-orient: vertical;
  `
}

const theme = new ThemeSettings()

export {
  theme
}
